import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment as env} from '@env/environment';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {WindowRefService} from '../window-ref.service';

const BASE_URL = env.serverUrl;

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    private options = {headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-Requested-With', 'XMLHttpRequest')};
    private fullurl: String = '';
    constructor(private httpClient: HttpClient, private winRef: WindowRefService) {
        this.fullurl = this.winRef.appConfigSite.apihost
    }

    public get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
        return this.httpClient.get(this.fullurl + BASE_URL + path, {headers: this.options.headers, params: params}).pipe(catchError(this.formatErrors));
    }

    public put(path: string, body: object = {}): Observable<any> {
        return this.httpClient
            .put(this.fullurl + BASE_URL + path, JSON.stringify(body), this.options)
            .pipe(catchError(this.formatErrors));
    }

    public post(path: string, body: object = {}): Observable<any> {
        return this.httpClient
            .post(this.fullurl + BASE_URL + path, JSON.stringify(body), this.options)
            .pipe(catchError(this.formatErrors));
    }

    public delete(path: string): Observable<any> {
        return this.httpClient.delete(this.fullurl + BASE_URL + path).pipe(catchError(this.formatErrors));
    }

    public formatErrors(error: any): Observable<any> {
        return throwError(error.error);
    }
}
